export default "__VITE_ASSET__DdQ82BUj__"